import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { ProductFilterComponent } from '@app/views/partials/layout/product-filter/product-filter.component';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DocumentService,
  ProductTypeValueService,
  CategoryService,
  BrandService,
  ManufacturerService,
} from '@app/api/api';
import { ProductService } from '@app/api/product.service';
import { environment } from 'environments/environment';
import { UtilService } from '@app/services/util.service';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
  selector: 'meu-search-by-category',
  templateUrl: './search-by-category.component.html',
  styleUrls: ['./search-by-category.component.scss'],
})
export class SearchByCategoryComponent implements OnInit, OnDestroy {
  host = environment.backendhost;

  @ViewChild(ProductFilterComponent, { static: false }) productFilter: ProductFilterComponent;

  totalProduct: any;
  pagesize: any = 24;
  pageIndex: any = 1;
  lstProductSearch = [];

  totalDoc: any;
  pagesizeDoc: any = 10;
  pageIndexDoc: any = 1;
  lstDoc = [];

  pageSizeOptions: number[] = [24, 36, 48];

  categoryName = '';
  categoryId = null;

  isListLayout: boolean = false;

  lstbrandHome: any = [];
  selectedBrandIds: string[] = [];

  lstmanufacturer: any = [];
  selectedManufacturerIds: string[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private documentService: DocumentService,
    private productTypeValueService: ProductTypeValueService,
    private categoryService: CategoryService,
    private brandService: BrandService,
    private manuService: ManufacturerService,
    private changeDetectorRef: ChangeDetectorRef,
    private productService: ProductService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.categoryId = params.categoryId;
      if (this.categoryId) {
        this.categoryService.apiCategoriesIdGet(this.categoryId).subscribe((r) => {
          if (r.success) {
            this.categoryName = r.data.name;
          }
        });
      }
      this.selectedBrandIds = [];
      this.selectedManufacturerIds = [];

      this.getListDoc();
      this.getListProduct();
    });

    this.getBrand();
    this.getManufacturer();
  }

  ngOnDestroy() {}

  getListProduct() {
    let params = new HttpParams();
    params = params.set('Filters', 'is_hidden==false');
    params = params.set('Sorts', '');
    params = params.set('Page', String(this.pageIndex));
    params = params.set('PageSize', String(this.pagesize));

    if (this.categoryId) {
      params = params.set('categoryId', this.categoryId);
    }

    if (this.selectedBrandIds.length) {
      this.selectedBrandIds.forEach((id) => {
        params = params.append('brandId', id);
      });
    }

    if (this.selectedManufacturerIds.length) {
      this.selectedManufacturerIds.forEach((id) => {
        params = params.append('manufacturerId', id);
      });
    }

    // console.log('FULL URL:', `${this.host}/api/fullProducts?${params.toString()}`);
    // console.log('selectedBrandIds:', this.selectedBrandIds);
    // console.log('selectedManufacturerIds:', this.selectedManufacturerIds);

    this.http.get(`${this.host}/api/fullProducts`, { params }).subscribe(
      (res: any) => {
        console.log('API Response:', res);
        if (res.success) {
          this.lstProductSearch = res.data.collection;
          this.totalProduct = res.data.total;

          for (let i = 0; i < this.lstProductSearch.length; i++) {
            // Kiểm tra cấu trúc dữ liệu trả về để map cho đúng
            // Nếu API trả về { product: {...} } thì dùng .product
            const productItem = this.lstProductSearch[i].product
              ? this.lstProductSearch[i].product
              : this.lstProductSearch[i];

            this.lstProductSearch[i].seo_name = UtilService.slugify(productItem.name);

            // Xử lý ảnh
            if (productItem.default_image) {
              this.lstProductSearch[i].default_image = this.host + productItem.default_image;
            } else {
              this.lstProductSearch[i].default_image = '/assets/media/logos/nodata.png'; // Ảnh mặc định nếu null
            }

            this.lstProductSearch[i].percentdiscount = this.calculatePercentPrice(
              productItem.price,
              productItem.origin_price
            );

            // Xử lý số lượng
            this.lstProductSearch[i].available_quantity =
              this.lstProductSearch[i].type_values &&
              this.lstProductSearch[i].type_values.length > 0
                ? this.calculateAvailableQuantity(this.lstProductSearch[i].type_values)
                : productItem.quantity;
          }
        } else {
          this.lstProductSearch = [];
          this.totalProduct = 0;
        }
        this.changeDetectorRef.detectChanges();
      },
      (err) => {
        console.error('API Error:', err);
      }
    );
  }

  toggleView(isList: boolean) {
    this.isListLayout = isList;
  }

  onFilterChange() {
    this.pageIndex = 1;
    this.getListProduct();
  }

  onFilterChangeFromComponent(event: { brandIds: string[]; manufacturerIds: string[] }) {
    this.selectedBrandIds = event.brandIds;
    this.selectedManufacturerIds = event.manufacturerIds;
    this.onFilterChange();
  }

  resetFilter() {
    this.selectedBrandIds = [];
    this.selectedManufacturerIds = [];
    this.onFilterChange();
  }

  filterShow() {
    if (this.productFilter) {
      this.productFilter.filterShow();
    }
  }

  getBrand() {
    this.brandService.apiBrandsGet('', '', 1, 1000).subscribe((res) => {
      if (res.success) {
        this.lstbrandHome = res.data.collection;
      }
    });
  }

  getManufacturer() {
    this.manuService.apiManufacturerGet('', '', 1, 360).subscribe((res) => {
      if (res.success) {
        this.lstmanufacturer = res.data.collection;
      }
    });
  }

  calculateAvailableQuantity(arrType = []) {
    let total = 0;
    for (let i = 0; i < arrType.length; i++) {
      total += arrType[i].quantity;
    }
    return total;
  }

  calculatePercentPrice(price, originPrice) {
    if (originPrice == 0) return 0;
    let percent = 0;
    percent = Math.round(100 - (price / originPrice) * 100);
    return percent;
  }

  getListDoc() {
    this.documentService
      .apiDocumentsSearchGet(
        '',
        'category_id==' + this.categoryId,
        '',
        this.pageIndexDoc,
        this.pagesizeDoc
      )
      .subscribe((res) => {
        if (res.success) {
          this.lstDoc = res.data.collection;
          this.totalDoc = res.data.total;
        }
        this.changeDetectorRef.detectChanges();
      });
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getListProduct();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pagesize = newSize;
    this.pageIndex = 1;
    this.getListProduct();
  }

  onPageChangeDoc(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndexDoc = pageNumber;
      this.getListDoc();
    }
  }

  onPageSizeChangeDoc(newSize: number) {
    this.pagesizeDoc = newSize;
    this.pageIndexDoc = 1;
    this.getListDoc();
  }

  selectProduct(productId, seoName) {
    if (productId && seoName) {
      this.router.navigate(['/product/' + productId + '/' + seoName + '/details']);
    }
  }
}
